var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevidenciaSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 435,
    viewBox: "0 0 438 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289 429C369.357 429 434.5 363.857 434.5 283.5C434.5 203.143 369.357 138 289 138C208.643 138 143.5 203.143 143.5 283.5C143.5 363.857 208.643 429 289 429Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 432C228.857 432 294 366.857 294 286.5C294 206.143 228.857 141 148.5 141C68.1426 141 3 206.143 3 286.5C3 366.857 68.1426 432 148.5 432Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195 294C275.357 294 340.5 228.857 340.5 148.5C340.5 68.1426 275.357 3 195 3C114.643 3 49.5 68.1426 49.5 148.5C49.5 228.857 114.643 294 195 294Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevidenciaSocial);
export default __webpack_public_path__ + "static/media/previdencia-social.005cd6350ead09aa6f9fda08ba716b3d.svg";
export { ForwardRef as ReactComponent };